import { SimpleTable } from '../../common/components/table/SimpleTable'
import { Snack, Text } from '@nike/eds'
import { Column, Row } from 'react-table'
import { TrackAndTrace } from '../../generated/graphql'
import React from 'react'

export interface TrackAndTraceEventsPropsType {
  trackAndTraceEvents: TrackAndTrace[]
  columns: Column[]
}

export function TrackAndTraceEvents({ trackAndTraceEvents, columns }) {
  return trackAndTraceEvents?.length ? (
    <SimpleTable
      title="Track & Trace"
      columns={columns}
      data={trackAndTraceEvents}
      getRowProps={(row: Row<{}>) => {
        return row.cells[0].value
          ? {
              className: 'tt-exception',
            }
          : {}
      }}
    />
  ) : (
    <div>
      <Text as="h2" font="title-3" style={{ margin: '0 0 20px 12px' }} className="vcenter">
        Track & Trace
      </Text>
      <Snack id="no-t&t-snack" onDismiss={() => {}} hideDismiss={true} status="info">
        No Track & Trace data
      </Snack>
    </div>
  )
}
